// import {
//   LOGIN_USER,
//   LOGIN_SUCCESS,
//   LOGOUT_USER,
//   LOGOUT_USER_SUCCESS,
//   API_ERROR,
//   CLEAR_API_ERROR ,
// } from "./actionTypes";

// const initialState = {
//   error: "",
//   loading: false,
//   user:null,
// };

// const login = (state = initialState, action) => {
//   switch (action.type) {
//     case LOGIN_USER:
//       state = {
//         ...state,
//         loading: true,
//       };
//       break;
//     case LOGIN_SUCCESS:
//       state = {
//         ...state,
//         loading: false,
//       };
//       break;
//     case LOGOUT_USER:
//       state = { ...state, isUserLogout: false };
//       break;
//     case LOGOUT_USER_SUCCESS:
//       state = { ...state, isUserLogout: true };
//       break;
//     case API_ERROR:
//       state = {
//         ...state,
//         error: action.payload,
//         loading: false,
//         isUserLogout: false,
//       };
//       break;
//     default:
//       state = { ...state };
//       break;
//   }
//   return state;
// };

// export default login;


import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  CLEAR_API_ERROR,
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  user: null,
  isUserLogout: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "", // Clear previous errors when login starts
      };
    
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload, // Update user data
        error: "", // Clear errors on success
      };

    case LOGOUT_USER:
      return {
        ...state,
        loading: true, // Optional: show loading for logout
        isUserLogout: false,
      };

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        loading: false, // Reset loading
        isUserLogout: true,
        user: null, // Clear user data on logout
        error: "", // Clear error on successful logout if needed
      };

    case API_ERROR:
      return {
        ...state,
        error: action.payload, // Set error message
        loading: false,
      };

    case CLEAR_API_ERROR:
      return {
        ...state,
        error: "", // Reset error state
      };

    default:
      return state; // Return unchanged state for unhandled actions
  }
};

export default login;
